import { DialogComponent } from '@theme/dialog';

const HEADING_MAP = {
  'custom-mold': 'Custom Mold Inquiry',
  'catalogue-shape': 'Catalogue Shape Inquiry',
  'partnership': 'Partnership Inquiry',
  'wishlist-inquiry': 'Send Wishlist to Sales',
  'catalog-request': 'Request the Catalog',
};

class ContactModalDialog extends DialogComponent {
  /**
   * Opens the dialog and activates the form for the given inquiry type.
   * Called via on:click="#contact-modal/openWithType/custom-mold"
   *
   * @param {string} type - The inquiry type slug
   * @param {Event} event
   */
  openWithType(type, event) {
    event?.preventDefault();
    this.#activateType(type);
    this.showDialog();
  }

  #activateType(type) {
    const panels = this.querySelectorAll('.contact-modal__form-panel');
    for (const panel of panels) {
      panel.hidden = panel.dataset.type !== type;
    }

    const { heading } = this.refs;
    if (heading) {
      heading.textContent = HEADING_MAP[type] || 'Contact Us';
    }

    // Reset any previous success/error states
    const messages = this.querySelectorAll('.contact-modal__message');
    for (const msg of messages) {
      msg.remove();
    }

    this.dataset.activeType = type;
  }
}

if (!customElements.get('contact-modal-dialog')) {
  customElements.define('contact-modal-dialog', ContactModalDialog);
}
